
import { register } from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-three-card-blogs.scss'

export default register(`section-three-card-blogs`, {
  onLoad() {
      $(`.three-card-blogs-slider`).slick(
          {
              autoplay: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true,
              dots: true,
              responsive: [
                  {breakpoint: 868 ,
                      settings: {
                      slidesToShow: 1,
                          arrows: true,
                          dots: false
                  }
                  }
                  ]
          }
      )
  },
  onUnload() {
      $(`.three-card-blogs-slider`).unslick()
  },
})
